export const typesStatusAccount = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  PROCESSING: 'PROCESSING',
  DISCONNECTED: 'DISCONNECTED'
};

export const statusAccountDestination = {
  [typesStatusAccount.SUCCESS]: {
    color: 'green',
    tooltip: 'La información de la cuenta bancaria se validó. Ya puedes realizar pagos a esta cuenta.',
    label: 'Conectado'
  },
  [typesStatusAccount.ERROR]: {
    color: 'failed',
    tooltip: 'No se logró hacer la conexión con esta cuenta.',
    label: 'Error'
  },
  [typesStatusAccount.PROCESSING]: {
    color: 'orange',
    tooltip: 'La información de la cuenta bancaria se encuentra en proceso de verificación.',
    label: 'En Proceso'
  },
  [typesStatusAccount.DISCONNECTED]: {
    label: 'Desconectada',
    color: 'failed',
    tooltip: 'La cuenta se encuentra desconectada.'
  }
};
export const statusAccountOrigin = {
  [typesStatusAccount.SUCCESS]: {
    color: 'green',
    tooltip: 'La información de la cuenta bancaria se validó. Ya puedes realizar pagos con esta cuenta',
    label: 'Conectado'
  },
  [typesStatusAccount.ERROR]: {
    color: 'failed',
    tooltip: 'No se logró hacer la conexión con esta cuenta.',
    label: 'Error'
  },
  [typesStatusAccount.PROCESSING]: {
    color: 'orange',
    tooltip: 'La información de la cuenta bancaria se encuentra en proceso de verificación.',
    label: 'En Proceso'
  },
  [typesStatusAccount.DISCONNECTED]: {
    label: 'Desconectada',
    color: 'failed',
    tooltip: 'La cuenta se encuentra desconectada.'
  }
};

export const statusAccountTransaction = {
  [typesStatusAccount.SUCCESS]: {
    label: 'Exitoso',
    color: 'green',
    tooltip: 'La transacción fue aprobada con éxito.'
  },
  [typesStatusAccount.ERROR]: {
    label: 'Fallido',
    color: 'failed',
    tooltip: 'La transacción no ha podido ser completada. '
  },
  [typesStatusAccount.PROCESSING]: {
    label: 'En proceso',
    color: 'orange',
    tooltip: 'El pago está pendiente de aprobación.'
  }
};

export const statusAccountLabel = {
  [typesStatusAccount.SUCCESS]: {
    color: 'green',
    label: 'Exitosa'
  },
  [typesStatusAccount.ERROR]: {
    color: 'failed',
    label: 'Error'
  },
  [typesStatusAccount.PROCESSING]: {
    color: 'orange',
    label: 'En proceso'
  },
  [typesStatusAccount.DISCONNECTED]: {
    label: 'Desconectada',
    color: 'failed'
  }
};
